<template>
  <svg width="40" height="40" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <circle cx="20" cy="20" r="20" :fill="isLeft ? '#6965f5' : '#FFFFFF'" />
      <path
        v-if="isPaused"
        d="M27.589 21.827l-10.47 7.068A2 2 0 0114 27.237V12.84a2 2 0 013.147-1.638l10.47 7.328a2 2 0 01-.028 3.296z"
        :fill="isLeft ? '#FFFFFF' : '#6965f5'"
      />
      <g v-else transform="translate(13 12)" :fill="isLeft ? '#FFFFFF' : '#6965f5'">
        <rect x="0" y="0" width="5" height="16" rx="1" />
        <rect x="9" y="0" width="5" height="16" rx="1" />
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PlayIcon extends Vue {
  @Prop({ type: Boolean }) isLeft: boolean;
  @Prop({ type: Boolean }) isPaused: boolean;
}
</script>
